import { TUserItem, TUserSelfInvitationItem } from "@/data/types";

export interface UsersState {
  items: TUserItem[];
  currrentUser: TUserItem | null;
  invitations: TUserSelfInvitationItem[];
}

export const DefaultUsersState: UsersState = {
  items: [],
  currrentUser: null,
  invitations: [],
};
